import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { Unitkerja } from "@/types"
import { getListUnitkerja } from "@/services/getData"

export default function MasterUnitkerjaPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listUnitkerja"],
    queryFn: getListUnitkerja,
  })

  const dataProdi = data?.filter((unitkerja: Unitkerja) => {
    return unitkerja?.unitkerja_group_key == "5"
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={dataProdi || []} columns={columns} />
    </div>
  )
}
